import Form from 'react-bootstrap/Form';

function ConsumersBankStatusFilterForm({ bankStatusFilter, changeBankStatusFilter, spinner }) {
  return (
    <Form.Select
      className="bo-filter"
      name="bankStatusFilter"
      id="bankStatusFilter"
      disabled={spinner}
      value={bankStatusFilter}
      onChange={e => changeBankStatusFilter('consumers', e.target.value)}
    >
      <option value="">All Bank Statuses</option>
      <option value="NOT_CONNECTED">Not Connected</option>
      <option value="CONNECTED">Connected</option>
      <option value="REFRESH_REQUIRED">Refresh Required</option>
      <option value="INVALID">Invalid</option>
    </Form.Select>
  );
}

export default ConsumersBankStatusFilterForm;
